export default {
  messages: {
    other: 'other',
    hello: '{word} hello！',
  },
};
